// Slug of the project, used to match it to the analytics.
// Must be set on the project's estate page on the backoffice
// Valid slug is required and sufficient for Jakte activation
const slug = 'le-premium';

// Website domain, without the http(s):// prefix
const domain = 'le-premium.fr';

// Full revo URL, false to disable the revo component
const revoUrl = false;

const locales = ['fr'];

const defaultLocale = 'fr';

// Source of the project, can be 'website' or 'landing'
const source = 'website';

// If the client has in-house tracking through Google Analytics
const googleAnalyticsID = 'GTM-PCB4KPFF';
const recaptchaSiteKey = '6LetjtIrAAAAAFyejRQ32dHf2lZQX5x7d3519cCY';

module.exports = {
  slug: slug,
  domain: domain,
  revoUrl: revoUrl,
  locales: locales,
  defaultLocale: defaultLocale,
  source: source,
  googleAnalyticsID: googleAnalyticsID,
  isMultiLocale: locales.length > 1,
  recaptchaSiteKey : recaptchaSiteKey
};



//////////////////
// WEBPACK FOOTER
// ./vars.js
// module id = 9
// module chunks = 0